import { makeRequest } from "cityads-v3/utils/apiUtils";

import {
  WEBMASTER_TYPE_PUBLISHER,
  WEBMASTER_TYPE_MEDIABUYER,
  WEBMASTER_TYPE_NETWORK,
} from 'cityads-v3/reducers/welcomeform';

export const SET_FORM = "welcomeform/SET_FORM";
export const SET_ERROR = "welcomeform/SET_ERROR";

export const SAVE_FORM = "welcomeform/SAVE_FORM";
export const SAVE_FORM_SUCCESS = "welcomeform/SAVE_FORM_SUCCESS";
export const SAVE_FORM_FAIL = "welcomeform/SAVE_FORM_FAIL";

export const PATCH_FORM = "welcomeform/PATCH_FORM";
export const PATCH_FORM_SUCCESS = "welcomeform/PATCH_FORM_SUCCESS";
export const PATCH_FORM_FAIL = "welcomeform/PATCH_FORM_FAIL";

export const LOAD_REGISTRATION_STEPS = "welcomeform/LOAD_REGISTRATION_STEPS";
export const LOAD_REGISTRATION_STEPS_SUCCESS = "welcomeform/LOAD_REGISTRATION_STEPS_SUCCESS";
export const LOAD_REGISTRATION_STEPS_FAIL = "welcomeform/LOAD_REGISTRATION_STEPS_FAIL";

export const LOAD_USER_REGISTRATION_STEP = "welcomeform/LOAD_USER_REGISTRATION_STEP";
export const LOAD_USER_REGISTRATION_STEP_SUCCESS = "welcomeform/LOAD_USER_REGISTRATION_STEP_SUCCESS";
export const LOAD_USER_REGISTRATION_STEP_FAIL = "welcomeform/LOAD_USER_REGISTRATION_STEP_FAIL";

export const LOAD_WEBMASTER_INFO = "welcomeform/LOAD_WEBMASTER_INFO";
export const LOAD_WEBMASTER_INFO_SUCCESS = "welcomeform/LOAD_WEBMASTER_INFO_SUCCESS";
export const LOAD_WEBMASTER_INFO_FAIL = "welcomeform/LOAD_WEBMASTER_INFO_FAIL";

export const LOAD_WEBMASTER_ADDITIONAL_DATA = "welcomeform/LOAD_WEBMASTER_ADDITIONAL_DATA";
export const LOAD_WEBMASTER_ADDITIONAL_DATA_SUCCESS = "welcomeform/LOAD_WEBMASTER_ADDITIONAL_DATA_SUCCESS";
export const LOAD_WEBMASTER_ADDITIONAL_DATA_FAIL = "welcomeform/LOAD_WEBMASTER_ADDITIONAL_DATA_FAIL";

export const PATCH_TRAFFIC_PARAMS = "welcomeform/PATCH_TRAFFIC_PARAMS";
export const PATCH_TRAFFIC_PARAMS_SUCCESS = "welcomeform/PATCH_TRAFFIC_PARAMS_SUCCESS";
export const PATCH_TRAFFIC_PARAMS_FAIL = "welcomeform/PATCH_TRAFFIC_PARAMS_FAIL";

export const LOAD_SUBSCRIPTIONS = "welcomeform/LOAD_SUBSCRIPTIONS";
export const LOAD_SUBSCRIPTIONS_SUCCESS = "welcomeform/LOAD_SUBSCRIPTIONS_SUCCESS";
export const LOAD_SUBSCRIPTIONS_FAIL = "welcomeform/LOAD_SUBSCRIPTIONS_FAIL";

export const SET_SUBSCRIPTION = "welcomeform/SET_SUBSCRIPTION";

export const SAVE_SUBSCRIPTION = "welcomeform/SAVE_SUBSCRIPTION";
export const SAVE_SUBSCRIPTION_SUCCESS = "welcomeform/SAVE_SUBSCRIPTION_SUCCESS";
export const SAVE_SUBSCRIPTION_FAIL = "welcomeform/SAVE_SUBSCRIPTION_FAIL";

export const SAVE_SUBSCRIPTIONS = "welcomeform/SAVE_SUBSCRIPTIONS";
export const SAVE_SUBSCRIPTIONS_SUCCESS = "welcomeform/SAVE_SUBSCRIPTIONS_SUCCESS";
export const SAVE_SUBSCRIPTIONS_FAIL = "welcomeform/SAVE_SUBSCRIPTIONS_FAIL";

export const URL_WEBMASTERS_PROFILE = '/saduka/webmasters/';
export const URL_WEBMASTER_ADDITIONAL_DATA = '/saduka/webmaster/additionalData/';

export function setForm({data = {}, page = 1} = {}) {
  return {
    type: SET_FORM,
    page,
    data
  };
}

export function setError(data = {}) {
  return {
    type: SET_ERROR,
    data
  };
}

export function saveForm(step) {
  return (dispatch, getState, extraArgument) => {
    const formData = getState().welcomeform.formData;
    const webmasterType = formData.webmaster_type;

    switch (webmasterType) {
      case WEBMASTER_TYPE_PUBLISHER:
      case WEBMASTER_TYPE_MEDIABUYER:
        formData.company = null;
        formData.domain = null;
        formData.work_models = null;
        break;
      case WEBMASTER_TYPE_NETWORK:
        formData.birthday = null;
        formData.traffic_type = null;
        formData.traffic_subtypes = null;
        break;
      // no default
    }

    return makeRequest('/saduka/webmasters/welcome', {
      types: [SAVE_FORM, SAVE_FORM_SUCCESS, SAVE_FORM_FAIL],
      options: {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          ...formData,
          step
        })
      },
      step
    })(dispatch, getState, extraArgument);
  }
}

export function loadRegistrationSteps() {
  return makeRequest('/saduka/registrationSteps', {
    types: [LOAD_REGISTRATION_STEPS, LOAD_REGISTRATION_STEPS_SUCCESS, LOAD_REGISTRATION_STEPS_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET',
    }
  });
}


export function loadUserRegistrationStep() {
  return makeRequest('/saduka/userRegistrationStep', {
    types: [LOAD_USER_REGISTRATION_STEP, LOAD_USER_REGISTRATION_STEP_SUCCESS, LOAD_USER_REGISTRATION_STEP_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET',
    }
  });
}

export function loadWebmasterInfo(userId) {
  return makeRequest(URL_WEBMASTERS_PROFILE + userId, {
    types: [LOAD_WEBMASTER_INFO, LOAD_WEBMASTER_INFO_SUCCESS, LOAD_WEBMASTER_INFO_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET',
    }
  });
}

export function loadWebmasterAdditionalData(userId) {
  return makeRequest(URL_WEBMASTER_ADDITIONAL_DATA + userId, {
    types: [LOAD_WEBMASTER_ADDITIONAL_DATA, LOAD_WEBMASTER_ADDITIONAL_DATA_SUCCESS, LOAD_WEBMASTER_ADDITIONAL_DATA_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET',
    }
  });
}

export function patchForm(url, data = {}, id) {
  return makeRequest(url, {
    types: [PATCH_FORM, PATCH_FORM_SUCCESS, PATCH_FORM_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'PATCH',
      body: JSON.stringify({
        ...data
      })
    },
    id
  });
}

export function loadSubscriptions() {
  return makeRequest(`/saduka/userSubscriptions/tree`, {
    types: [LOAD_SUBSCRIPTIONS, LOAD_SUBSCRIPTIONS_SUCCESS, LOAD_SUBSCRIPTIONS_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET',
    }
  });
}

export function setSubscription(id, value) {
  return {
    type: SET_SUBSCRIPTION,
    id,
    value,
  };
}

export function saveSubscriptions() {
  return async (dispatch, getState, additionalData) => {
    const { userSubscriptionsById, userSubscriptionsChangedById } = getState().welcomeform;

    const subscriptionsToSave = Object.keys(userSubscriptionsChangedById)
      .filter(id => userSubscriptionsChangedById[id])
      .map(id => userSubscriptionsById[id])
    ;

    dispatch({ type: SAVE_SUBSCRIPTIONS });

    try {
      const result = await Promise.all(
        subscriptionsToSave.map(subscription => makeRequest(`/saduka/userSubscriptions`, {
          types: [SAVE_SUBSCRIPTION, SAVE_SUBSCRIPTION_SUCCESS, SAVE_SUBSCRIPTION_FAIL],
          options: {
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({ userSubscription: { type_id: subscription.id, is_active: subscription.is_active } })
          },
          id: subscription.id,
        })(dispatch, getState, additionalData))
      );

      dispatch({ type: SAVE_SUBSCRIPTIONS_SUCCESS, additional: result });
    } catch (err) {
      dispatch({ type: SAVE_SUBSCRIPTIONS_FAIL, additional: err });
    }
  };
}
